import { axiosInstance } from "./client";

export const getServicePartner = async (servicePartnerId: string) =>
  axiosInstance
    .get(`/driver/service-partners/${servicePartnerId}`)
    .then((response) => response.data);

export const getServicePartnerCollection = async (
  servicePartnerCollectionId: string,
) =>
  axiosInstance
    .get(`/driver/service-partners/collections/${servicePartnerCollectionId}`)
    .then((response) => response.data);
